export default class ConversationTeaserEvent {
    constructor(type, title, description) {
        this._type = type;
        this._title = title;
        this._description = description;
    }

    get type() {
        return this._type;
    }

    get title() {
        return this._title;
    }

    get description() {
        return this._description;
    }
}

ConversationTeaserEvent.SHOW = "ConversationTeaserEvent.SHOW";
ConversationTeaserEvent.HIDE = "ConversationTeaserEvent.HIDE";